<template>
  <b-modal
    id="service-system-modal"
    ref="serviceSystemModal"
    :title="$t('breadcrumb.serviceSystemSetting')"
    size="lg"
    hide-footer
    no-close-on-backdrop
    class="service-system-modal"
    @hide="onHide"
  >
    <validation-observer
      ref="serviceSystemForm"
      #default="{ invalid }"
    >
      <b-form @submit.prevent="onSubmit">
        <!-- Project Selection -->
        <validation-provider
          v-slot="{ errors }"
          :name="$t('breadcrumb.project')"
          rules="required"
        >
          <b-form-group
            :label="$t('breadcrumb.project')"
            class="mb-2"
          >
            <n-async-multi-select
              v-model="formData.projectIds"
              repository="project"
              selection-key="id"
              selection-label="translations"
              :query="{ isActive: true }"
              included-all
              always-fresh
              :placeholder="$t('placeholder.selectProject')"
              :state="errors.length > 0 ? false : null"
              :init-options="editData ? editData.projects.map(project => project.projectId) : []"
              :all-option-value="'ALL_PROJECT'"
              @change="handleProjectChange"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <!-- Category Selection -->
        <validation-provider
          v-slot="{ errors }"
          :name="$t('field.category')"
          rules="required"
        >
          <b-form-group
            :label="$t('field.category')"
            class="mb-2"
          >
            <n-async-single-select
              v-model="formData.serviceCategoryCode"
              repository="serviceCategory"
              selection-key="code"
              selection-label="translations"
              :state="errors.length > 0 ? false : null"
              :placeholder="$t('placeholder.selectCategory')"
              :init-options="formData.serviceCategoryCode"
              @change="handleServiceCategoryChange"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <!-- Type Selection -->
        <validation-provider
          v-slot="{ errors }"
          :name="$t('field.type')"
          rules="required"
        >
          <b-form-group
            :label="$t('field.type')"
            class="mb-2"
          >
            <n-async-single-select
              v-model="formData.serviceTypeCode"
              repository="serviceType"
              selection-key="code"
              selection-label="translations"
              :reduce="true"
              :state="errors.length > 0 ? false : null"
              :readonly="!formData.serviceCategoryCode"
              :placeholder="$t('placeholder.selectType')"
              :query="{
                serviceCategoryCode: formData.serviceCategoryCode,
              }"
              :always-fresh="true"
              @change="handleServiceTypeChange"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <!-- Sub-Type Selection -->
        <!-- <validation-provider
          v-slot="{ errors }"
          :name="$t('field.subType')"
          :rules="{
            required: tmpList.serviceSubType.length > 0,
          }"
        >
          <b-form-group
            :label="$t('field.subType')"
            class="mb-2"
          >
            <n-async-single-select
              v-model="formData.serviceSubTypeCode"
              repository="serviceSubType"
              selection-key="code"
              selection-label="translations"
              :reduce="true"
              :state="errors.length > 0 ? false : null"
              :readonly="!formData.serviceTypeCode"
              :placeholder="$t('placeholder.selectSubType')"
              :query="{
                serviceTypeCodes: formData.serviceTypeCode,
              }"
              :always-fresh="true"
              v-bind:tmpList.sync="tmpList.serviceSubType"
              @change="handleServiceSubTypeChange"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider> -->

        <!-- Form Actions -->
        <div class="form-actions mt-3">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            @click="clickCancel"
          >
            {{ $t('button.cancel') }}
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="invalid || loading"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mr-1"
            />
            {{ $t('button.save') }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import NAsyncMultiSelect from '@/components/NAsyncMultiSelect.vue'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'

export default {
  name: 'ServiceSystemModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    NAsyncMultiSelect,
    NAsyncSingleSelect,
  },
  props: {
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        projectIds: [],
        serviceCategoryCode: null,
        serviceTypeCode: null,
        serviceSubTypeCode: null,
      },
      defaultFormData: {
        projectIds: [],
        serviceCategoryCode: null,
        serviceTypeCode: null,
        serviceSubTypeCode: null,
        projects: [],
        serviceCategory: null,
        serviceType: null,
        serviceSubType: null,
      },
      serviceCategory: null,
      serviceType: null,
      serviceSubType: null,
      projects: null,
      isSubmit: false,
      tmpList: {
        serviceSubType: [],
      }
    }
  },
  watch: {
    editData(newVal) {
      if (newVal) {
        this.initializeEditData(newVal)
      }
    },
  },
  mounted() {
    this.isSubmit = false
    this.defaultFormData = JSON.parse(JSON.stringify(this.formData))
    if (this.editData) {
      this.initializeEditData(this.editData)
    }
  },
  methods: {
    initializeEditData(data) {
      this.formData = {
        projectIds: data.projectIds || [],
        serviceCategoryCode: data.serviceCategoryCode,
        serviceTypeCode: data.serviceTypeCode,
        serviceSubTypeCode: data.serviceSubTypeCode,
        projects: data.projects,
        serviceCategory: data.serviceCategory || this.editData.serviceCategory,
        serviceType: data.serviceType || this.editData.serviceType,
        serviceSubType: data.serviceSubType || this.editData.serviceSubType,
      }
    },
    resetForm() {
      this.formData = JSON.parse(JSON.stringify(this.defaultFormData))
      this.projects = []
      this.serviceCategory = null
      this.serviceType = null
      this.serviceSubType = null
      this.projectIds = []
      this.serviceCategoryCode = null
      this.serviceTypeCode = null
      this.serviceSubTypeCode = null
      this.editData = null
      console.log('resetForm', this.editData)
    },
    show() {
      if (!this.editData) {
        this.formData = JSON.parse(JSON.stringify(this.defaultFormData))
      }
      if (this.$refs.serviceSystemModal) {
        this.$refs.serviceSystemModal.show()
      }
    },
    hide() {
      if (this.$refs.serviceSystemModal) {
        this.$refs.serviceSystemModal.hide()
      }
    },
    onHide() {
      if (!this.isSubmit) {
        this.$emit('hide')
      }
      this.resetForm()
    },
    handleProjectChange(projects) {
      this.projects = projects
      this.$emit('projectChange', projects)
    },
    async onSubmit() {
      const isValid = await this.$refs.serviceSystemForm.validate()
      if (!isValid || this.loading) return

      const data = {
        projectIds: this.formData.projectIds,
        projects: this.projects,
        serviceCategoryCode: this.formData.serviceCategoryCode,
        serviceTypeCode: this.formData.serviceTypeCode,
        serviceCategory: this.serviceCategory || this.editData?.serviceCategory,
        serviceType: this.serviceType || this.editData?.serviceType,
        serviceSubTypeCode: this.formData.serviceSubTypeCode,
        serviceSubType: this.serviceSubType || this.editData?.serviceSubType,
      }

      this.isSubmit = true
      this.$emit('submit', data)
      this.hide()
      this.resetForm()
    },
    clickCancel() {
      this.isSubmit = false
      this.resetForm()
      this.$emit('cancel')
      this.hide()
    },
    handleServiceCategoryChange(data) {
      this.serviceCategory = data
      this.formData.serviceTypeCode = null
    },
    handleServiceTypeChange(data) {
      this.serviceType = data
      this.formData.serviceSubTypeCode = null
      this.serviceSubType = null
    },
    handleServiceSubTypeChange(data) {
      this.serviceSubType = data
    },
  },
}
</script>

<style lang="scss" scoped>
.service-system-modal {
  ::v-deep .modal-body {
    padding: 1rem;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 0.75rem;
  border-top: 1px solid #dee2e6;
}

::v-deep {
  .form-group {
    margin-bottom: 0.5rem;
  }

  label {
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }
}
</style>
